import Lesson from '@/models/list/Lesson';

import APIService from '@/services/APIService';

export default {

  index(params) {
    return APIService.get('/lessons', { params, rOptions: { model: Lesson, many: true } });
  },

  show(id, params) {
    return APIService.get(`/lessons/${id}`, { params, rOptions: { model: Lesson } });
  },
  /**
   * Получить данные об уроке
   * https://gitlab.pfdo.ru/sdo/sdo/-/wikis/Работа-с-сущностями/Урок
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getLesson(id, params) {
    return APIService.get(`/lessons/${id}`, { params });
  },
  createLesson(data) {
    return APIService.post('/lessons', data);
  },
  updateLesson(id, data) {
    return APIService.put(`/lessons/${id}`, data);
  },
  deleteLesson(id) {
    return APIService.delete(`/lessons/${id}`);
  },

  /**
   * Отметить урок как пройденный
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  passLesson(id, data) {
    return APIService.post(`/lessons/${id}/passed`, data);
  },

  // Контент урока
  createVideo(id, data) {
    return APIService.post(`/lessons/${id}/contents/links`, data);
  },
  deleteVideo(id) {
    return APIService.delete(`/lessons/contents/links/${id}`);
  },
  updateVideo(id, data) {
    return APIService.put(`/lessons/contents/links/${id}`, data);
  },

  createFile(id, data) {
    return APIService.post(`/lessons/${id}/contents/files`, data);
  },
  deleteFile(id) {
    return APIService.delete(`/lessons/contents/files/${id}`);
  },
  updateFile(id, data) {
    return APIService.put(`/lessons/contents/files/${id}`, data);
  },

  createStream(id, data) {
    return APIService.post(`/lessons/${id}/contents/streams`, data);
  },
  deleteStream(id) {
    return APIService.delete(`/lessons/contents/streams/${id}`);
  },
  updateStream(id, data) {
    return APIService.put(`/lessons/contents/streams/${id}`, data);
  },

  createLecture(id, data) {
    return APIService.post(`/lessons/${id}/contents/lectures`, data);
  },
  deleteLecture(id) {
    return APIService.delete(`/lessons/contents/lectures/${id}`);
  },
  updateLecture(id, data) {
    return APIService.put(`/lessons/contents/lectures/${id}`, data);
  },

  getUserLesson(id, userid, params) {
    return APIService.get(`/lessons/${id}/users/${userid}`, { params });
  },
};
